// extracted by mini-css-extract-plugin
export var active = "_1g-d";
export var blink = "_1g-e";
export var container = "_1g-5";
export var controls = "_1g-0";
export var controlsRight = "_1g-1";
export var fakeCursor = "_1g-c";
export var hidden = "_1g-b";
export var quillContainerSmall = "_1g-7";
export var quillEditor = "_1g-6";
export var quillEditorSmall = "_1g-8";
export var quillFormatButtons = "_1g-a";
export var quillToolbar = "_1g-9";
export var removePadding = "_1g-2";
export var state = "_1g-3";
export var stateTitle = "_1g-4";